import { render, staticRenderFns } from "./LoanOfferDetails.vue?vue&type=template&id=16536d50"
import script from "./LoanOfferDetails.vue?vue&type=script&lang=js"
export * from "./LoanOfferDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports